import { IApiEpPageconfig } from "@smp/api";
import { usePostCountQuery } from "@smp/graphql";

import { useDateCurrent } from "@/hooks/use_date_current";
import { gqlClient } from "@/hooks/use_graphql";

export const Posts = ({ pageconfig }: { pageconfig: IApiEpPageconfig }) => {
  const { dateCurrent } = useDateCurrent();

  const { data: postCountData } = usePostCountQuery(gqlClient, {
    page_config__in: [pageconfig.id],
    scheduled_for__gte: dateCurrent.toISOString(),
    archived: false,
  });

  if (!postCountData) return null;

  return <>{postCountData.post_count.scheduled}</>;
};
